import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TLabelCase } from '../types/label-case.type';

export const CreateLabelCaseValidationSchema = z.object({
  name: z.string().min(1),
  color: z.string().min(1),
});

export type TCreateLabelCaseValidation = z.infer<typeof CreateLabelCaseValidationSchema>;
export type TCreateLabelCasePayload = TCreateLabelCaseValidation;
export type TCreateLabelCaseResponse = ApiResponse<TLabelCase>;

export const createLabelCase = async (payload: TCreateLabelCasePayload): Promise<TCreateLabelCaseResponse> => {
  const url = '/label-case';
  return axiosInstance.post(url, payload);
};

type TUseCreateLabelCaseMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof createLabelCase, AxiosErrorCustom>;
};

export const useCreateLabelCaseMutation = ({ mutationConfigOptions }: TUseCreateLabelCaseMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};

  return useMutation({
    mutationFn: createLabelCase,
    ...restConfigOptions,
  });
};
